import { render, staticRenderFns } from "./AvatarPicker.vue?vue&type=template&id=73a83d54&scoped=true&"
import script from "./AvatarPicker.vue?vue&type=script&lang=js&"
export * from "./AvatarPicker.vue?vue&type=script&lang=js&"
import style0 from "./AvatarPicker.vue?vue&type=style&index=0&id=73a83d54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a83d54",
  null
  
)

export default component.exports